module.exports = __webpack_public_path__ + "img/navegam.ecaea2f2.svg";